<template>
  <div class="field">
    <multiselect v-bind="$attrs"
                 :value="value"
                 @input="onInput"
    />
    <label class="field-label" v-if="fieldLabel">{{ fieldLabel }}</label>

    <span v-if="error" class="error-message">
      <span v-for="(e, index) in error" :key="index">
        {{ e }}
      </span>
    </span>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'ChcMultiselectInput',
  components: {Multiselect},
  inheritAttrs: false,
  props: {
    fieldLabel: {
      type: String,
      default: null
    },
    error: {
      default: null
    },
    value: {
      default: null
    }
  },
  methods: {
    onInput (newValue) {
      this.$emit('input', newValue)
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../style/_variables.scss";
label {
  position: static;
  padding-top: .25rem;
  color: $md-blue;
  font-size: .875rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/ChcMultiselectInput.vue